import {useTranslation} from 'react-i18next';
import {useReservation} from '../../context/reservation';
import {useFetchPrivacyPolicySettings} from '../../hooks/useFetchPrivacyPolicySettings';
import Link from '../common/Link';

function PrivacyPolicyLink({className}: {className?: string}) {
  const {t} = useTranslation();
  const {housingId} = useReservation();

  const {hasCustomPrivacyPolicy, documentDownload, isLoading} =
    useFetchPrivacyPolicySettings({housingId});

  return hasCustomPrivacyPolicy ? (
    <Link
      download
      href={documentDownload}
      label={t('privacy_policy')}
      disabled={isLoading || !documentDownload}
      className={className}
    />
  ) : (
    <Link
      href={t('guest_privacy_policy_link')}
      label={t('privacy_policy')}
      className={className}
    />
  );
}

export {PrivacyPolicyLink};
